import {createBreakpoints} from '@mui/system';

export const breakpointOverrides = createBreakpoints({
    values: {
        base: 0,
        xs: 360,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536
    }
});

declare module '@mui/material/styles' {
    interface BreakpointOverrides {
        base: true; // added as new 0
        xs: true;
        sm: true;
        md: true;
        lg: true;
        xl: true;
    }
}
